'use client';

import { useState, useEffect } from 'react';
import { formatCurrency } from '@/lib/utils';

interface PriceDisplayProps {
  priceUsd?: number;
  priceArs?: number | null; // Optional priceArs prop for direct ARS price
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function PriceDisplay({ 
  priceUsd = 0, 
  priceArs,
  className = '',
  size = 'md'
}: PriceDisplayProps) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Determine final price to display
  let finalPrice: number | null = null;
  
  // Priority: 1. Direct priceArs if provided
  if (priceArs !== undefined && priceArs !== null) {
    finalPrice = Number(priceArs);
  } 
  // 2. Use priceUsd as fallback if available
  else if (priceUsd > 0) {
    finalPrice = priceUsd;
  }
  
  // Determine text size based on prop
  const textSizeClass = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  }[size];

  if (!isMounted) {
    return <span className={`${className} ${textSizeClass}`}>Cargando...</span>;
  }

  return (
    <span className={`${className} ${textSizeClass}`}>
      {finalPrice !== null ? formatCurrency(finalPrice) : 'Precio no disponible'}
    </span>
  );
} 